import { useEffect, useState } from "react";
import { useIsClient } from "@bitcart/hooks";
// src/hooks/scroll.ts
const useWindowScrollThreshold = ({ axis, value }) => {
	const isClient = useIsClient();
	const [isScrolled, setIsScrolled] = useState(false);
	useEffect(() => {
		if (isClient) {
			const handleScroll = () => setIsScrolled((axis === "horizontal" ? window.scrollX : window.scrollY) > value);
			handleScroll();
			window.addEventListener("scroll", handleScroll);
			return () => window.removeEventListener("scroll", handleScroll);
		}
	}, [
		axis,
		isClient,
		value
	]);
	return { isScrolled };
};
export { useWindowScrollThreshold };

//# sourceMappingURL=scroll.js.map